import React, { PureComponent } from 'react';
import Styles from '../constants/Styles';
import ReceiveMoxiScreen from '../screens/ReceiveMoxiScreen';
import MoxiModalContext from './MoxiModalContext';

class ModalView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { screen, modalVisible } = this.props;
    let contextProps = this.context;

    let backgroundColor = 'white';
    if ([ReceiveMoxiScreen.viewName].includes(screen.viewName)) backgroundColor = '#181C2F';

    return (
      <div style={{ ...Styles.container, backgroundColor, display: 'flex' }}>
        {React.createElement(screen, { ...contextProps, ...this.props })}
      </div>
    );
  }
}

ModalView.contextType = MoxiModalContext;

export default ModalView;
